'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItem = function ListItem(_ref) {
    var title = _ref.title,
        text = _ref.text,
        children = _ref.children,
        imgSrc = _ref.imgSrc,
        iconName = _ref.iconName,
        altText = _ref.altText,
        iconColor = _ref.iconColor,
        className = _ref.className;

    var content = title ? _react2.default.createElement("span", { className: "luna-list__content" }, _react2.default.createElement("span", { className: "luna-list__title" }, title), _react2.default.createElement("span", { className: "luna-list__text" }, text, children)) : [text, children];
    var prefix = imgSrc ? _react2.default.createElement("span", { className: "luna-list__prefix" }, _react2.default.createElement("img", { className: "luna-image", alt: altText, src: imgSrc })) : iconName && _react2.default.createElement("div", { className: "luna-list__prefix" }, _react2.default.createElement(_Icon2.default, { name: iconName, size: "small", color: iconColor, title: altText }));
    var listItemClassNames = (0, _classnames2.default)('luna-list__item', className);
    return _react2.default.createElement("li", null, _react2.default.createElement("div", { className: listItemClassNames }, prefix, content));
};
ListItem.propTypes = {
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
    text: _propTypes2.default.string.isRequired,
    imgSrc: _propTypes2.default.string.isRequired,
    iconName: _propTypes2.default.string.isRequired,
    altText: _propTypes2.default.string,
    iconColor: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string.isRequired
};
ListItem.defaultProps = {
    altText: ''
};
exports.default = ListItem;
//# sourceMappingURL=ListItem.js.map